import { createFileRoute } from "@tanstack/react-router";

import CustomizePageGate from "./-components/CustomizePageGate";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/customize/"
)({
  component: CustomizePageGate,
});
